import React from "react";
import PropTypes from "prop-types";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import MenuDrawer from "./MenuDrawer";
import MenuToolbar from "./MenuToolbar";
import { makeStyles } from "@material-ui/core";
import { filterArrayEqual } from "../../functions/arrays";
import { useBeforeunload } from 'react-beforeunload';

const drawerWidth = 270;
const drawerWidthMobile = 200;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('xs')]: {
     // width: `calc(100% - ${drawerWidthMobile}px)`,
      marginLeft: drawerWidthMobile,
    },
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidthMobile}px)`,
      marginLeft: drawerWidthMobile,
    },
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.up('lg')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.up('xl')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    flexGrow: 1,
  },
  toolbarLogo: {
    [theme.breakpoints.up('xs')]: {
      width: 100,
    },
  },
  titleHeader: {
    color: 'rgb(0, 0, 1)',
    fontWeight: 'bold',
    fontSize: '0.875rem'
  }
}));
const ToolBar = props => {

  const { renderContainer, onNotification, onLogout, notifications, userState, timeSession, parameters, userQuestions, setOnLogoutClose } = props

  const classes = useStyles();

  useBeforeunload((event) => handleClose(event));

  const handleClose = (event) => {
    //console.log(event)
    //event.returnValue = "dfgdfgdfg"
    setOnLogoutClose()
    //event.preventDefault()
    
    //
  }
  
  const [openSliderDrawer, setSliderDrawer] = React.useState(false);
  const handleSliderDrawerOpen = () => {
    setSliderDrawer(!openSliderDrawer);
  };

  const closeSliderDrawer = () => {
    setSliderDrawer(!openSliderDrawer)
  }

  return (
    <div className={classes.root}>
      <CssBaseline />

      <AppBar
        elevation={0}
        position="fixed"
        className = {classes.appBar} >
        <MenuToolbar
          classes = {classes}
          onNotification = { onNotification }
          handleSliderDrawerOpen = { handleSliderDrawerOpen }
          notifications = { notifications }
          onLogout = { onLogout } 
          setOnLogoutClose = {setOnLogoutClose}
        />
      </AppBar>

      <MenuDrawer 
        // anchor = { 'left' }
        primary = {filterArrayEqual(parameters, 'name', 'PRIMARY_COLOR').length > 0 ? filterArrayEqual(parameters, 'name', 'PRIMARY_COLOR')[0].value : '#444242'}
        open={openSliderDrawer}
        closeDrawer = {closeSliderDrawer}
        userState = { userState } 
        userQuestions = {userQuestions}
      />

      <main className={classes.content}>
        <div className={classes.toolbar} />
          { renderContainer }
          { timeSession }
      </main>
    </div>
  );
};

ToolBar.propTypes = {
  onLogout:PropTypes.func.isRequired,
};

export default ToolBar;
